export const VERIFICATION_TOKEN_COOKIE = 'verification-token';
export const EMAIL_VERIFIED_COOKIE = 'email-verified';
export const VERIFICATION_EMAIL_COOKIE = 'verification-email';
export const VERIFICATION_LAST_RESEND_COOKIE = 'verification-last-resend';
export const VERIFICATION_RESEND_STATUS_RESET_TIMEOUT_MS = 60_000;
export const EMAIL_VERIFIED_COOKIE_MAX_AGE_SECONDS = 60;

export const getVerificationCookieOptions = () =>
  ({
    secure: process.env.NODE_ENV === 'production',
    sameSite: 'lax',
    path: '/',
  }) as const;
